// Public product details and evergreen guides used by the homepage.
// Free-tier wording is supported by the RaceVoice App Store listing.
export const APPLE_APP_STORE_URL = 'https://apps.apple.com/app/racevoice/id6761085881';
export const SIM_DOWNLOAD_URL = '/downloads/RaceVoiceSim_Setup.exe';

export const CALLOUTS = [
  { key: 'entry', label: 'Entry', mph: 88, file: '/callouts/entry-88.mp3', description: 'Know your speed as you arrive.' },
  { key: 'minimum', label: 'Minimum', mph: 64, file: '/callouts/minimum-64.mp3', description: 'Hear what you carry through the corner.' },
  { key: 'exit', label: 'Exit', mph: 92, file: '/callouts/exit-92.mp3', description: 'Measure your run onto the straight.' },
];

export const STARTER_GUIDES = [
  {
    slug: '2026-06-20-what-is-racevoice',
    category: 'Meet your voice coach',
    title: 'Your next track day, with RaceVoice.',
    description: 'See how spoken corner speeds, telemetry, and video fit into a day at the track.',
    image: 'hero.jpg',
    readingTime: 5,
  },
  {
    slug: '2026-06-24-hear-your-speed-in-car-coach',
    category: 'Listen to the difference',
    title: 'What does a voice coach sound like?',
    description: 'Real callouts, the corners behind them, and how to choose the numbers you want to hear.',
    image: 'hero.jpg',
    readingTime: 6,
  },
  {
    slug: '2026-07-11-mounting-your-phone',
    category: 'Get ready to drive',
    title: 'One phone. One mount. Ready to go.',
    description: 'A practical guide to mounting your phone for a clear GPS signal and steady track footage.',
    image: 'hero.jpg',
    readingTime: 6,
  },
];

export const FAQS = [
  {
    question: 'Can I try RaceVoice for free?',
    answer: 'Yes. The free version lets you enable one voice callout at a time, so you can try it at a corner you want to work on. An upgrade unlocks multiple speed callouts across the track. See the app for current upgrade pricing.',
  },
  {
    question: 'What equipment do I need?',
    answer: 'Start with your phone, a secure mount, and a way to hear your callouts. RaceVoice uses the phone’s GPS and motion sensors, plus its camera when you record video. You do not need to wire a data logger into the car.',
    link: '/blog/2026-07-11-mounting-your-phone',
    linkText: 'Read the phone-mounting guide',
  },
  {
    question: 'Will it work at my track?',
    answer: 'Choose from the built-in track library, use GPS to locate nearby tracks, or record a custom track by driving a lap. You can select which corners and speed callouts you want to work on.',
    link: '/blog/2026-06-19-complete-walkthrough',
    linkText: 'Explore track setup',
  },
  {
    question: 'How do I hear the voice coaching?',
    answer: 'RaceVoice plays callouts through your phone’s audio output. Use a compatible helmet speaker, earbud, or Bluetooth connection to your car’s stereo. Set up and check your audio before going on track.',
  },
  {
    question: 'What is the difference between the app, Cloud, and Sim?',
    answer: 'The RaceVoice phone app is your on-track companion for voice coaching, recording, and review. RaceVoice Cloud is the website where you review uploaded sessions. RaceVoiceSim is a free Windows companion that captures supported sim sessions and uploads them to Cloud.',
  },
  {
    question: 'Which phones can I use?',
    answer: 'RaceVoice is available for iPhone on the App Store. Check the store listing for current device compatibility. Android download availability is being confirmed; check back here for an updated Google Play link.',
    id: 'android-availability',
  },
];
